import { queryOptions, useQuery } from "@tanstack/react-query";
import { neWebApi } from "../../../../api";
import { neWebUrls, neWebQueryKeys } from "../../../../ne-web-urls";
import type { PPAInvoiceSupplier } from "../PPAInvoiceNumberRangesPage.types";

export function usePPAInvoiceSuppliers() {
  return useQuery(suppliersQueryOptions);
}

const suppliersQueryOptions = queryOptions({
  queryKey: neWebQueryKeys.ppaInvoicing.suppliers(),
  queryFn: () => fetchSuppliers()
});

async function fetchSuppliers() {
  const response = await neWebApi.get<Array<PPAInvoiceSupplier>>(
    neWebUrls.api.ppaInvoiceNumberRangeSuppliers()
  );

  return response.data;
}
